<template>
  <section class="wrapper">
    <div>
      <div class="page-panel-header">
        <span>{{ $t('home.solutions' /* 场景化方案 */) }}</span>
      </div>
      <ul class="page-panel-desc-list">
        <li>{{ $t('home.solutionsDesc1' /* 支持高层战略决策的智能系统 */) }}</li>
        <li>{{ $t('home.solutionsDesc2' /* 场景化智能决策支持系统 */) }}</li>
        <li>{{ $t('home.solutionsDesc3' /* 汽车行业首家数据分析 BI 平台 */) }}</li>
      </ul>
    </div>
    <div class="page-panel-content">
      <div class="solutions-tags">
        <div
          v-for="item in currentData
            .filter((item) => item.groupId !== 2098619)
            .slice(0, 3)"
          :key="item.groupId"
          class="solutions-tags__item"
          :class="{ 'is-active': item.groupId === currentActiveId }"
          @click="handleItemClick(item)"
        >
          <div class="solutions-tags__item--title" :class="{ 'solutions-tags__item--title--en': isEn }">
            {{ item.groupName }}
          </div>
        </div>
      </div>
      <div class="solutions-content" :class="{ 'solutions-content-en': isEn }">
        <div
          v-for="item in currentData"
          :key="item.groupId"
          class="solutions-content__item"
          :class="{ 'is-active': item.groupId === currentActiveId, 'solutions-content__item-en': isEn && '用户生命周期管理' === item.groupName_zh_CN }"
          :inert="item.groupId !== currentActiveId"
        >
          <template v-if="solutionsRoutesMap[item.groupName_zh_CN]">
            <img v-if="isEn" :src="solutionsRoutesMapSvg[item.groupName_zh_CN]" :style="{ height: solutionsRoutesMapSvgHeight[[item.groupName_zh_CN]] }" />
            <component v-else :is="`Fig${solutionsRoutesMap[item.groupName_zh_CN]}`" />
            <router-link
              class="page-ghost-button"
              active-class=""
              exact-active-class=""
              :to="{ name: solutionsRoutesMap[item.groupName_zh_CN] }"
            >
              <span>{{ $t('home.viewDetail' /* 查看详情 */) }}</span>
            </router-link>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { cloneDeep } from "lodash";
import lang from '@/lang';
import FigCarLifeCycle from "./fig-car-life-cycle.vue";
import FigUserLifeCycle from "./fig-user-life-cycle.vue";
import FigIntelligentDecision from "./fig-intelligent-decision.vue";
import FigCarLifeCycleSvg from "./fig-car-life-cycle-en.svg";
import FigUserLifeCycleSvg from "./fig-user-life-cycle-en.svg";
import FigIntelligentDecisionSvg from "./fig-intelligent-decision-en.svg";

export default {
  name: "Solutions",
  components: {
    FigCarLifeCycle,
    FigUserLifeCycle,
    FigIntelligentDecision,
  },
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      isEn: lang.locale === 'en',
      currentData: [],
      // 当前激活的方案 ID
      currentActiveId: null,
      solutionsRoutesMap: {
        车型生命周期管理: "CarLifeCycle",
        用户生命周期管理: "UserLifeCycle",
        运营管理智能决策: "IntelligentDecision",
      },
      solutionsRoutesMapSvg: {
        车型生命周期管理: FigCarLifeCycleSvg,
        用户生命周期管理: FigUserLifeCycleSvg,
        运营管理智能决策: FigIntelligentDecisionSvg,
      },
      solutionsRoutesMapSvgHeight: {
        车型生命周期管理: '308px',
        用户生命周期管理: '402px' ,
        运营管理智能决策: '316px',
      },
    };
  },
  watch: {
    data: {
      handler(val) {
        if (val.length) {
          this.currentActiveId = val.filter(
            (item) => item.groupName_zh_CN !== "智能客服"
          )[0].groupId;
        } else {
          this.currentActiveId = null;
        }
        this.currentData = cloneDeep(val) || [];
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleItemClick(item) {
      this.currentActiveId = item.groupId;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/common";
.wrapper {
  @include content-wrapper;
  margin-top: 40px;
  margin-bottom: 80px;
  .page-panel-content {
    display: flex;
  }
  .solutions-tags {
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
    width: 216px;
    flex-direction: column;
    position: relative;
    z-index: 20;
    &__item {
      cursor: pointer;
      border-radius: 4px;
      padding: 16px 20px;
      height: 150px;
      background: url(/images/portal/home/solutions-tags-bg.png) no-repeat;
      background-size: 100%;
      position: relative;
      user-select: none;
      &.is-active,
      &:hover {
        &::after {
          opacity: 1;
        }
        .solutions-tags__item--title {
          color: #fff;
        }
      }
      &:nth-child(1) {
        background-position: center 0;
        &::after {
          background-position: center -150px;
        }
      }
      &:nth-child(2) {
        background-position: center -300px;
        &::after {
          background-position: center -450px;
        }
      }
      &:nth-child(3) {
        background-position: center -600px;
        &::after {
          background-position: center -750px;
        }
      }
      &::after {
        content: "";
        width: 100%;
        height: 100%;
        background: url(/images/portal/home/solutions-tags-bg.png) no-repeat;
        background-size: 100%;
        position: absolute;
        inset: 0;
        z-index: 0;
        pointer-events: none;
        opacity: 0;
        transition: opacity 0.3s;
      }
      &--title {
        width: 84px;
        color: #6e758a;
        font-size: 20px;
        line-height: 28px;
        position: relative;
        z-index: 10;
        transition: color 0.3s;
        &--en {
          width: auto;
        }
      }
    }
  }
  .solutions-content {
    &-en {
      background: #F7F8FA;
    }
    height: 480px;
    margin-top: 15px;
    margin-left: -52px;
    flex: 1;
    background: #f6f9ff;
    box-shadow: inset 0 10px 30px rgba(51, 102, 255, 0.06);
    border-radius: 4px;
    position: relative;
    z-index: 10;
    &__item {
      &-en {
        padding-top: 12px;
        .page-ghost-button {
          bottom: 12px !important;
        }
      }
      display: flex;
      justify-content: center;
      padding-top: 56px;
      opacity: 0;
      position: absolute;
      inset: 0;
      z-index: 0;
      pointer-events: none;
      transition: opacity 0.8s;
      &.is-active {
        opacity: 1;
        z-index: 10;
        pointer-events: auto;
      }
      svg {
        width: 834px;
        height: 308px;
      }
      .page-ghost-button {
        height: 36px;
        position: absolute;
        bottom: 48px;
        z-index: 10;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}
</style>
